module.exports = __webpack_public_path__ + "7b28518dc3226933a7f9595a9f122c91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.svg
// module id = 328
// module chunks = 0